<template>
  <section class="hero">
    <div style="display: flex; flex-direction: column;width: 100%;">
      <div style="display: flex; flex-direction: row;">
        <div class="bottom">
          <div class="numberTitle">基本信息</div>
          <div class="sub">
            <div class="divider"></div>
            <div class="subTitle">我的公司</div>
          </div>
          <div
            style="display: flex; flex-direction: row;align-items: center;color: black;font-size: 16px;">
            <div v-if="companyInfo != null">{{ this.companyInfo.company }}</div>
            <a v-else @click="showAddLicense()">企业未认证，请点击认证</a>
          </div>
          <div class="sub">
            <div class="divider"></div>
            <div class="subTitle">我的会员</div>
          </div>
          <div
            style="display: flex; flex-direction: row;align-items: center;color: black;font-size: 15px;">
            <div v-if="vipInfo != null">{{ getVipDate() }} <br>在线职位数：{{ getOnLineJobs() }}</div>
            <div v-else style="display: flex; flex-direction: row;align-items: center;">
              <div style="margin-right: 10px">暂无</div>
              <a @click="openVip()"
                 style="border-radius: 20px;border: #9A9A9A solid 1px;color: #333333;font-size: 13px;padding: 5px 10px">开通会员</a>
            </div>
          </div>
        </div>
        <div class="topright">
          <div style="display: flex; flex-direction: column;align-items: center;">
            <div style="font-size: 20px;color: black">职位发布</div>
            <a class="btn" @click="showChooseType">发布职位</a>
          </div>
        </div>
      </div>
      <ChoosePostJobTypeDialog
        :visible.sync="showChoose"
        type="image"
        width="460px"
        @gotoOnlineJob="gotoOnlineJob"
        @gotoOfflineJob="gotoOfflineJob"
      />
      <CenterDialog
        :visible.sync="showQrCode"
        type="image"
        width="350px"
        :image="imageQrcode"
        :showActions="false"
      />
      <CenterDialog
        :visible.sync="showToBProgram"
        type="image"
        width="240px"
        title="请前往小程序继续操作"
        :image="imageQrcodeToB"
        :showActions="false"
      />
      <AddLicenseDialog
        :visible.sync="showAddLicenseDialog"
        width="450px"
        @confirm="confirm"
      />
    </div>
  </section>
</template>

<script>
import ChoosePostJobTypeDialog from "@/views/toc/ChoosePostJobTypeDialog.vue";
import CenterDialog from "@/views/toc/ShowImageDialog.vue";
import api from "@/api";
import AddLicenseDialog from "@/views/toc/AddLicenseDialog.vue";


export default {
  name: 'HomeToC',
  components: {AddLicenseDialog, CenterDialog, ChoosePostJobTypeDialog,},
  created() {
    this.getCompanyInfo();
    this.getVipInfo()
  },
  data() {
    return {
      showChoose: false,
      showQrCode: false,
      showToBProgram: false,
      imageQrcode: "https://www.mgadmob.com/mp/img/postImage.png",
      imageQrcodeToB: require("@/assets/img/qrcode_shangjia.jpg"),
      companyInfo: null,
      vipInfo: null,
      showAddLicenseDialog: false,
    }
  },
  methods: {
    showChooseType() {
      this.showChoose = true;
    },
    gotoOnlineJob() {
      this.showChoose = false;
      this.showQrCode = true;
    },
    gotoOfflineJob() {
      this.$router.push({name: 'postjobstep1'});
    },
    getCompanyInfo() {
      api.statistics
        .getCompanyInfo()
        .then(res => {
          if (res.code == 2000) {
            if (res.data.length > 0) {
              this.companyInfo = res.data[res.data.length - 1]
            }
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    getVipInfo() {
      api.statistics
        .getVipInfo()
        .then(res => {
          if (res.code == 2000) {
            if (res.data.length > 0) {
              this.vipInfo = res.data[res.data.length - 1]
            }
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    openVip() {
      this.showToBProgram = true;
      // this.$router.push({name: 'openvip'});
    },
    getVipDate() {
      if (this.vipInfo.endTime != null && this.vipInfo.endTime != undefined) {
        return '有效期到：' + this.vipInfo.endTime
      }
      return '暂无'
    },
    getOnLineJobs() {
      if (this.vipInfo.onlineJobNumber == undefined || this.vipInfo.leavePublishJobNumber == undefined || this
        .vipInfo.onlineJobNumber == null || this.vipInfo.leavePublishJobNumber == null) {
        return '0'
      }
      return this.vipInfo.onlineJobNumber - this.vipInfo.leavePublishJobNumber
    },
    showAddLicense() {
      this.showAddLicenseDialog = true;
    },
    confirm(data) {
      this.companyInfo = {
        company: data.company,
        id: data.companyId
      }
    },
  }
}
</script>

<style scoped>
.hero {
  padding-top: 70px;
  display: flex;
  padding-left: 5%;
  padding-right: 2%;
  background: #F6F7FB;
  height: 100vh;
}

.topright {
  display: flex;
  flex-direction: row;
  margin-left: auto;
  background: white;
  border-radius: 10px;
  width: 20%;
  justify-content: center;
  align-items: center;
}

.numberTitle {
  color: black;
  font-size: 23px;
  font-weight: bold;
}

.subTitle {
  color: black;
  font-size: 18px;
  margin-left: 5px;
}

.sub {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
  margin-top: 30px;
}

.divider {
  width: 3px;
  background: #4095E5;
  height: 25px
}

.btn {
  background: #ECF5FF;
  border: 1px solid #C7E2FF;
  border-radius: 50px;
  text-align: center;
  margin-top: 20px;
  padding: 5px 20px;
  font-size: 16px;
}

.bottom {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: white;
  margin-right: 20px;
  border-radius: 10px;
  padding: 35px 30px;
}
</style>
